import React from "react";
import { IIdColorTitle } from "ui/Scripts/source/models/common/idColorTitle";
import { DialogButtonType } from "ui/Scripts/source/models/enums";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog, IDialogButton } from "../framework/dialog";
import { Base } from "ui/Scripts/source/framework/base";

//CalendarTaskCategoryListLine
export interface ICalendarTaskCategoryTextProp {
    item: IIdColorTitle;
}

export class CalendarTaskCategoryText extends React.Component<ICalendarTaskCategoryTextProp, {}> {
    render() {
        const item = this.props.item;
        const bordered = Base.isWhite(item.color);
        return (
            <span
                className={"stateText thick wide"}
                style={{ backgroundColor: item.color, color: Base.invertColor(item.color), border: bordered ? "1px solid lightgray" : null, lineHeight: bordered ? "22px" : null }}>
                {item?.title}
            </span>
        );
    }
}

//CalendarTaskCategoryListLine
export interface ICalendarTaskCategoryListLineProp {
    classes?: string;
    item: IIdColorTitle;
    selected: boolean;
    onClick: (urgencyClassIdunitId: string) => void;
}

export class CalendarTaskCategoryListLine extends React.Component<ICalendarTaskCategoryListLineProp, {}> {
    render() {
        const item = this.props.item;
        return (
            <div className={"line" + (this.props.classes ? " " + this.props.classes : "") + (this.props.selected ? " selected" : "")} onClick={() => this.props.onClick(item.id)}>
                <div className="row">
                    <div className="col-12" style={{ margin: "1px" }}>
                        <CalendarTaskCategoryText item={item} />
                    </div>
                </div>
            </div>
        );
    }
}

//CalendarTaskCategoryList
export interface ICalendarTaskCategoryListProp {
    categories: IIdColorTitle[];
    categoryId: string;
    onLineClick: (categoryId: string) => void;
}

export class CalendarTaskCategoryList extends React.Component<ICalendarTaskCategoryListProp, {}> {
    render() {
        const props = this.props;
        return (
            <div className="lineContainer calendarTaskcategories">
                {props.categories.map(category => (
                    <CalendarTaskCategoryListLine
                        key={category.id}
                        item={category}
                        selected={category.id === props.categoryId}
                        onClick={props.onLineClick}
                    />
                ))}
            </div>
        );
    }
}

interface SelectCalendarTaskCategoryProps {
  classes?: string;
  nextPreviousMode?: boolean;
  categories: IIdColorTitle[];
  categoryId: string;
  onOk: (categoryId: string) => void;
  onCancel: () => void;
  onPrevious?: () => void;
}

export const SelectCalendarTaskCategory = (
    props: SelectCalendarTaskCategoryProps
) => {
    const buttons: IDialogButton[] = [];
    const dialogClasses = "selectUrgencyClassDialog" + (!Base.isNullOrEmpty(props.classes) ? " " + props.classes : "");

    if (props.nextPreviousMode) {
        if (props.onPrevious) {
            buttons.push({
                title: Translations.Previous,
                buttonType: DialogButtonType.Default,
                onClick: props.onPrevious,
            });
        }
        if (props.onOk) {
            buttons.push({
                title: Translations.Next,
                buttonType: DialogButtonType.Default,
                onClick: () => {
                    props.onOk(props.categoryId);
                },
            });
        }
    } else {
        buttons.push({
            title: Translations.Cancel,
            buttonType: DialogButtonType.Default,
            onClick: props.onCancel,
        });
    }

    return (
        <Dialog
            classes={dialogClasses}
            title={Translations.SelectCategory}
            body={
                <div className="largeDialogContent">
                    <CalendarTaskCategoryList
                        categories={props.categories}
                        categoryId={props.categoryId}
                        onLineClick={(categoryId) => props.onOk(categoryId)}
                    />
                </div>
            }
            buttons={buttons}
            onClose={props.onCancel}
        />
    );
};
